/**
 * Servicio de Dashboard - Comunicación con API
 */

import apiClient from './api.js';

class DashboardService {

  /**
   * Obtener resumen general
   */
  async obtenerResumenGeneral() {
    return apiClient.get('/dashboard/resumen');
  }

  /**
   * Obtener estadísticas de producción
   */
  async obtenerEstadisticasProduccion(periodo = 'mes') {
    return apiClient.get(`/dashboard/produccion?periodo=${periodo}`);
  }

  /**
   * Obtener estadísticas de ventas
   */
  async obtenerEstadisticasVentas(periodo = 'mes') {
    return apiClient.get(`/dashboard/ventas?periodo=${periodo}`);
  }

  /**
   * Obtener estadísticas de calidad
   */
  async obtenerEstadisticasCalidad(periodo = 'mes') {
    return apiClient.get(`/dashboard/calidad?periodo=${periodo}`);
  }

  /**
   * Obtener estadísticas de posventa
   */
  async obtenerEstadisticasPosventa(periodo = 'mes') {
    return apiClient.get(`/dashboard/posventa?periodo=${periodo}`);
  }

  /**
   * Obtener actividad reciente
   */
  async obtenerActividadReciente(limite = 20) {
    return apiClient.get(`/dashboard/actividad?limite=${limite}`);
  }
}

export default new DashboardService();
